import { Pipe, PipeTransform } from '@angular/core';
import { EncriptionService } from '../services/Encription.service';

@Pipe({
  name: 'permissionFilter'
})
export class PermissionFilterPipe implements PipeTransform {
  constructor(private encriptionService: EncriptionService) {}

  transform(itemId: string): boolean {
    const permissionList = this.encriptionService.DecryptList();
    if (permissionList === null || permissionList === undefined)
      return false;

    const permission = permissionList.find(perm => perm === itemId);
    return permission? true : false;
  }
}